import { useEffect, useState } from "react";
import useWindowDimensions from "../../../hooks/useWindowDimension";
import { loadDisableAds } from "../../../utils/storage";

export const ChatHead = () => {
  const isDesktop = useWindowDimensions();
  const [isLoaded, setIsLoaded] = useState(false);
  const env = process.env.REACT_APP_ENV;
  const isDisableAds = loadDisableAds() && env === "development";

  const handleLoaded = (value: boolean) => {
    setIsLoaded(value);
  };

  useEffect(() => {
    if (isLoaded || !isDesktop || isDisableAds) {
      return;
    }

    try {
      if (window.location.pathname.indexOf("/ifr/") !== 0) {
        loadScript(() => {
          handleLoaded(true);
        });

        patchAddEventListener();
      } else {
        console.debug("[ads] not showing chatHead in iframes");
      }
    } catch (e) {
      console.debug("[ads] error loading chatHead");
    }
  }, [isLoaded, isDesktop, isDisableAds]);

  return null;
};

const loadScript = (cb: () => void) => {
  const js = document.createElement("script");

  js.async = true;
  js.onload = cb;
  js.src =
    "https://www.cwchmb.com/im_jerky?" +
    "vlmi=1" +
    "&vlm=1" +
    "&vlmd=v.vfgte.com" +
    "&vlmcid=d35e5c47-8e8d-4bcf-86e8-b285e231bf95" +
    "&subID1=VGIL_999528998_REDG_CHHD_ALL" +
    "&source=TS507-999528998" +
    "&affiliateID=108124" +
    "&Location_Alias=CHHD" +
    "&livefeed={performerName}" +
    "&providers=streamate" +
    "&genders=f%2Cff" +
    "&skin=1" +
    "&canHide=1" +
    "&containerAlignment=center" +
    "&cols=4" +
    "&rows=1" +
    "&number=4" +
    "&background=transparent" +
    "&useFeed=1" +
    "&animateFeed=1" +
    "&smoothAnimation=1" +
    "&ratio=1" +
    "&verticalSpace=10px" +
    "&horizontalSpace=10px" +
    "&colorFilter=0" +
    "&colorFilterStrength=0" +
    "&AuxiliaryCSS=%0A" +
    "&token=fdecb600-9bd9-11ec-b9c9-0fb5c35adf26" +
    "&isLive=1" +
    "&sound=off";

  document.head.appendChild(js);
};

const patchAddEventListener = () => {
  if (document.readyState !== "loading") {
    const { addEventListener: oldAddEventListener } = document;

    document.addEventListener = (type: string, listener: (this: Document, ev: Event) => any, options?: boolean | AddEventListenerOptions): void => {
      if (type !== "DOMContentLoaded" || listener.name !== "injectWidget") {
        oldAddEventListener.call(document, type, listener, options);
        return;
      }

      listener.call(document, new Event("injectWidget"));
      document.addEventListener = oldAddEventListener;
    };
  }
};
